import qs from 'qs'

const fields = [
  'slug',
  'locale',
  'title',
  'externalLocation',
  'secondaryTitle',
  'dateStart',
  'dateEnd',
]

export const queryExhibitionEntryBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        ...queryFragmentSeo,
        ...queryFragmentBlocks,
        ...queryFragmentEducationEntries,
        ...queryFragmentEventEntries,
        ...queryFragmentJournalEntries,
        ...queryFragmentProjectEntries,
        ...queryFragmentPressEntries,
        ...queryFragmentPressKitEntries,
        linkTopPage: queryFragmentLink,
        coverImage: '*',
        images: {
          fields: '*',
          limit: 4
        },
        localizations: {
          fields: fields
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `exhibition-entries?${query}`
}
